const RestApiIcon = ({ className = "w-6 h-6 text-white" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* The Outer Circle to match your FastAPI style */}
    <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
    
    {/* Outgoing Request Arrow */}
    <path d="M7 9h10l-3-3" />
    
    {/* Incoming Response Arrow */}
    <path d="M17 15H7l3 3" />
  </svg>
);

export default RestApiIcon;